import React from 'react';

import './SellWhatsNext.scss';

import ConfirmationExitBox from '../../ConfirmationExitBox';
import config from '../../../../config/config';
import TRP from '../../../Shared/TRP/TRP';
import dollarSignMonitor from '../../../../assets/images/dollar-sign-monitor.svg';
import bankSellConfirm from '../../../../assets/images/bank-sell-confirm.svg';
import recurringCalendar from '../../../../assets/images/recurring-calendar.svg';
import sellDashboard from '../../../../assets/images/sell-dashboard.svg';
import { appendBasePath } from '../../../../utils/nav.utils';

export const SellWhatsNext = ({ noBanksOnFile }) => (
  <div className="sell-whats-next-exit-container">
    <div>
      <div className="sell-whats-next-exit-heading">What&apos;s next?</div>
      <div className="row">
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-submit-another-trade'}
            className={'e2e-confirm-submit-another-trade'}
            heading={'Submit Another Trade'}
            subHeading={
              <span>
                Buy, sell, or exchange using your <TRP /> accounts.
              </span>
            }
            image={dollarSignMonitor}
            exitLocation={`${config.url}/usis/transactions/landing`}
          />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          {noBanksOnFile ? (
            <ConfirmationExitBox
              id={'confirm-add-bank'}
              className={'e2e-confirm-add-bank'}
              heading={'Add a Bank'}
              subHeading={`Save time by adding a bank before your next transaction.`}
              image={bankSellConfirm}
              exitLocation={`${config.url}${appendBasePath('/addbank')}`}
            />
          ) : (
            <ConfirmationExitBox
              id={'confirm-setup-recurring'}
              className={'e2e-confirm-setup-recurring'}
              heading={'Set Up Recurring Investments'}
              subHeading={`Scheduling automatic deposits makes adding to your portfolio simple`}
              image={recurringCalendar}
              exitLocation={`${config.url}/usis/transactions/automatic`}
            />
          )}
        </div>
        <div className="col-sm-12 col-md-4 col-lg-4">
          <ConfirmationExitBox
            id={'confirm-view-dashboard'}
            className={'e2e-confirm-view-dashboard'}
            heading={'View Dashboard'}
            subHeading={`Review your portfolio and track how your investments are performing.`}
            image={sellDashboard}
            exitLocation={`${config.url}/usis/my-accounts/dashboard`}
          />
        </div>
      </div>
    </div>
  </div>
);

export default SellWhatsNext;
